import React, { Component } from 'react'
import DisbursementForm from './components/DisbursementForm'
import { postDisbursementAction, viewDisbursementAction } from '../actions/disbursement.actions';
import { connect } from "react-redux";
import { Modal, ModalBody, Col, Card, CardBody, Row, Spinner } from "reactstrap";
import { MdArrowDownward } from 'react-icons/md';


let csv_format = "";
class DisbursementFormView extends Component {

    state = {
    
    }
    componentDidMount() {
        if (this.props.match.params.id) {
            this.props.dispatch(viewDisbursementAction(this.props.match.params.id));
        }
    }
    
    createDisbursement = (value) => {
        let reader = new FileReader();
        const idFromBrowser = this.props.match?.params?.id;
        const idForDisbursementFetched = this.props.viewDisbursement.response?.id;
        try {
            if (value?.csv_file?.file) {
                reader.readAsDataURL(value.csv_file.file);
                reader.onloadend = () => {
                    csv_format = reader.result;
                    let filterDataFormat = csv_format.substring(37);
                    let refineData = {
                        name: value && value.nameOfDisbursement,
                        totalAmount: value && value.amount,
                        numberOfRecipients: value && value.numberOfRecipients,
                        fileBase64: filterDataFormat,
                        // institutionId: value && value.institution ? value.institution.dispatch: '',
                        type: value && value.disbursementType === 'INSTANT' ? 1 : 2,
                        scheduledDisbursementTime: value && value.scheduledDate && value.disbursementType === "SCHEDULED" ? (value.scheduledDate?.replace("T", " ") + ":00") : null
                    };
                    
                    if(idFromBrowser == idForDisbursementFetched) {
                        refineData.id = idFromBrowser
                    }
                    this.props.dispatch(postDisbursementAction(refineData, this.props.history));
                };
            }
        } catch (error) {
            console.error(error)
        }
    };
    createFormData = (data) => {
        let disbursementData;
        if(data) {
            disbursementData = {
                nameOfDisbursement: data.batchName,
                amount: data.totalAmount,
                numberOfRecipients: data.numberOfRecipients,
                disbursementType: data.disbursementType === "instant" ? '1' : '2',
                scheduledDate: data.scheduledDisbursementTime && data.scheduledDisbursementTime.length > 1 && data.disbursementType === "instant" ? null : data.scheduledDisbursementTime?.replace(" ", "T")
            }
        }
        return disbursementData;
    };


    render() {
        const id = this.props.match.params?.id;
        const data = id && this.props.viewDisbursement.response;
        return (
            <React.Fragment>
                <div> 
                    <DisbursementForm
                        postDisbursement={this.props.postDisbursement}
                        fileUrl={data?.fileUrl}
                        onSubmit={this.createDisbursement}
                        initialValues={this.createFormData(data)}
                        loading={this.props.viewDisbursement.loading}
                        id={id}
                    />
                </div>
                <Modal isOpen={this.props.postDisbursement.loading} centered={true}>
                    <ModalBody>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody style={{ textAlign: "center" }}>
                                    <div>
                                        <MdArrowDownward size={80} style={{ color: "#004266", marginTop: "2rem" }} className="vert-move" />
                                    </div>
                                    <br />
                                    <br />
                                    <div>
                                        <h5>Disbursement in progress...</h5>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        )
    }
}

export default connect((state) => ({
    postDisbursement: state.postDisbursement,
    viewDisbursement: state.viewDisbursement
}))(DisbursementFormView);

